var map = {
	"./stadium1.jpg": 6784,
	"./stadium10.jpg": 3978,
	"./stadium11.jpg": 6135,
	"./stadium12.jpg": 3288,
	"./stadium13.jpg": 4469,
	"./stadium14.jpg": 1054,
	"./stadium15.jpg": 6891,
	"./stadium2.jpg": 1119,
	"./stadium3.jpg": 8450,
	"./stadium4.jpg": 7681,
	"./stadium5.jpg": 308,
	"./stadium6.jpg": 8435,
	"./stadium7.jpg": 9910,
	"./stadium8.jpg": 6117,
	"./stadium9.jpg": 4936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7280;